// extracted by mini-css-extract-plugin
export default {"articleItemContainer":"styleModule_articleItemContainer__OF0vc","contentWrapper":"styleModule_contentWrapper__ScXyL","wrapper":"styleModule_wrapper__NFFUb"};